
export const macroConstants = {
    FETCH_MACRO_REQUEST: 'FETCH_MACRO_REQUEST',
    FETCH_MACRO_SUCCESS: 'FETCH_MACRO_SUCCESS',
    FETCH_MACRO_FAILURE: 'FETCH_MACRO_FAILURE',
    CLEAR_MACROS: 'CLEAR_MACROS'
}